module.exports = __webpack_public_path__ + "static/media/main idea.6cc486c1.mp3";